.click-to-call {
  &__button {
    width: fit-content;
  }

  &__link {
    display: flex;
    align-items: center;
    width: fit-content;
  }
}
